var Flickity = require('flickity');

function HeroImage(el) {
  var t = this;

  t.slider = el.querySelector('.js-slider');

  if( t.slider && t.slider.childElementCount > 1 ) {
    var slider = new Flickity( t.slider, {
      cellAlign: 'center',
      contain: true,
      adaptiveHeight: true,
      prevNextButtons: false,
      pageDots: false,
      setGallerySize: true,
      autoPlay: 5000
    } );
  }

}

module.exports = HeroImage;